import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(private commonService: CommonService) { }

  /**
   *
   * @param key
   * @param value
   */
  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *
   * @param key
   */
  get<T>(key: string): T | null {
    const val = localStorage.getItem(key);
    if (val && val !== 'undefined') {
      return this.commonService.jsonParse<T>(val);
    }
    return null;
  }

  /**
   *
   */
  clear() {
    localStorage.clear();
  }

  /**
   * 指定したkeyがローカルストレージに保存されているかを返す
   * @param key
   */
  checkLocalstrageData(key: string) {
    const tempArray = this.get(key);
    if (Array.isArray(tempArray) && tempArray.length > 0) {
      return true;
    }
    return false;
  }
}
